module.exports = __webpack_public_path__ + "img/swiper_3.0_2_3.24c439a8.webp";